import React from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';

import { asyncSimpleModal } from '../../lib/common';
import useCategoryEdit from '../queries/category/useCategoryEdit';
import { CategoryAttachments } from '../../views/category/detail/types';

/**
 * 카테고리 수정 모달에서 동작하는 로직을 포함하고 있는 custom hook
 */
const useCategoryUpdateModal = (
  form: WrappedFormUtils,
  setIsEditable: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const { editCategory } = useCategoryEdit();

  /**
   * 카테고리 수정 모달의 확인 버튼 클릭 시
   * @return {Promise<void>}
   */
  const onClickSaveConfirmBtn = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 수정',
      message: '1차 카테고리 수정 사항을 저장 하시겠습니까?',
    });

    // 취소 버튼 클릭 시 mutate 하지 않음
    if (!result) return;

    // 에러 발생 시 해당 위치로 스크롤
    form.validateFieldsAndScroll((err, values) => {
      if (err) return;

      const { name, status, memo, sortType } = values;
      // 카테고리 편집 요청 시 보내는 request data
      const formData = {
        name,
        status,
        memo: memo || null,
        sortType,
        categoryAttachments: values.categoryAttachments?.map(({ path }: CategoryAttachments) => ({ type: 0, path })),
      };

      editCategory.mutate(formData, {
        onSuccess: () => {
          setIsEditable(false);
        },
      });
    });
  };

  /**
   * 카테고리 수정 취소 모달의 확인 버튼 클릭 시
   * @return {Promise<void>}
   */
  const onClickCancelConfirmBtn = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 수정',
      message: '정말 취소하시겠습니까?',
    });

    // 취소 버튼 클릭 시 다시 편집 중인 상태로 돌아가고 수정 전 form state로 reset
    if (!result) return;

    setIsEditable(false);
    form.resetFields();
  };

  return { onClickSaveConfirmBtn, onClickCancelConfirmBtn };
};

export default useCategoryUpdateModal;
